// extracted by mini-css-extract-plugin
module.exports = {"badges":"Map_badges__2XY_O","coordinates":"Map_coordinates__1HgN5"};